/* tslint:disable */

/**
 */
export class inline_response_200 {
    valueContour?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/inline-_response-_200.ts